import { dashboardAxios, buildAuthenticationHeaders } from './global';

const getBrands = credentials =>
  dashboardAxios.get(`/messages-10dlc/api/account/${ credentials.accountId }/brands`, {
    ...buildAuthenticationHeaders(credentials)
  });

const getBrand = (brandId, credentials) => dashboardAxios.get(`/messages-10dlc/api/account/${credentials.accountId}/brand/${brandId}`, {
  ...buildAuthenticationHeaders(credentials)
});

const createBrand = (credentials, brand) => dashboardAxios.post(`/messages-10dlc/api/account/${credentials.accountId}/brand`, brand, {
  ...buildAuthenticationHeaders(credentials)
});

const deactivateBrand = (credentials, brandId) => dashboardAxios.delete(`/messages-10dlc/api/account/${credentials.accountId}/brand/${brandId}`, {
  ...buildAuthenticationHeaders(credentials)
});

const updateBrand = brand =>
  dashboardAxios.patch(`/api/v1/tendlc/brands/${brand.brand_id}?apiKey=${brand.api_key}`, brand);

const getFeedback = (brandId, credentials) =>
  dashboardAxios.get(`/messages-10dlc/api/account/${credentials.accountId}/brand/${brandId}/feedback`, {
    ...buildAuthenticationHeaders(credentials)
  });

const updateAndVerifyBrand = brand =>
  dashboardAxios.patch(`/api/v1/tendlc/brands/${brand.brand_id}/verify?apiKey=${brand.api_key}`, brand);

const getVettings = (brandId, apiKey) =>
  dashboardAxios.get(`/api/v1/tendlc/brands/${brandId}/vetting/requests`, {
    params: { apiKey },
  });

const createVetting = vetting =>
  dashboardAxios.post(
    `/api/v1/tendlc/brands/${vetting.brand_id}/vetting/requests?apiKey=${vetting.account_id}`,
    vetting
  );

export {
  getBrands,
  getBrand,
  createBrand,
  getVettings,
  createVetting,
  updateBrand,
  deactivateBrand,
  getFeedback,
  updateAndVerifyBrand
};
